import { graphql } from '../../graphql/graphql';

export const schoolPageBySlugQuery = graphql(
  `
    query SchoolPageBySlug($id: ID!, $slug: Uri!) {
      redirectSchoolSlugFromSchoolSlug(id: $id, slug: $slug)
      schoolPageBySlug(id: $id, slug: $slug) {
        slug
        id
        tracking {
          pageData {
            pageType
            siteSection
            site
            siteSubSection
          }
          useUserContext
          schoolContext {
            schema
            data {
              school_name
              school_sector
            }
          }
        }
        pageTitleByParts {
          part1
          part2
        }
        breadCrumbs {
          title
          url
        }
        schoolContacts {
          title
          url
          isExternal
          key
          variant
          rel
          iconInfo {
            name
            placement
          }
        }
        tabs {
          title
          fullPath
        }
      }
    }
  `,
  [],
);
